module.exports = __webpack_public_path__ + "static/media/android-chrome-128x128.b99c3de8.png";